import { observer } from "mobx-react"
import React from "react"
import data from "../../../Configs/JSON/options.json"
import "../../../styles/Calculator/CalculateOptions.less"

const Options = observer(( props ) => {
  return   (
    <div className={"CollapseRoot"}>
      {data.map((data, index) => (
        <div className="optionsContainer" key={data.id} onClick={() => props.onClickFunction(data.id)} id={data.id}>

          <div className="optcontblk media">
            <div className="img-blk">
              <img className="optionsIcon" src={require(`../../../assets/Calculator/${data.icon}`)} alt={data.title}/>
            </div>
            <div className="media-body">
              <h5 className="ttl">{data.calculatorScr2AnswereA}</h5>
              <p className="p">{data.calculatorScr2AnswereB}</p>
            </div>
            <img className="optionsArrow st" src={require(`../../../assets/Calculator/${data.arrow}`)} alt={data.title}/>
          </div>
        </div>
      ))}
    </div>
  )  
})

export default Options
